export default "__VITE_ASSET__DmCO6OMf__"